import React from 'react';

// Renders one of three scale types (nps/likert use the same numbered-option
// layout, stars uses an icon row) driven entirely by CSS custom properties
// so it re-skins automatically when the parent brand attribute changes.
function RatingScale({ scaleType, value, onChange, min = 1, max = 5, minLabel, maxLabel, segmented = false }) {
  if (scaleType === 'stars') {
    const stars = Array.from({ length: max }, (_, i) => i + 1);
    return (
      <div className="rating-scale rating-scale--stars">
        {stars.map((star) => (
          <button
            key={star}
            type="button"
            className={`rating-scale-star${value >= star ? ' filled' : ''}`}
            aria-label={`${star} star${star > 1 ? 's' : ''}`}
            aria-pressed={value === star}
            onClick={() => onChange(star)}
          >
            <i className="material-icons">{value >= star ? 'star' : 'star_border'}</i>
          </button>
        ))}
      </div>
    );
  }

  const options = [];
  for (let i = min; i <= max; i++) options.push(i);

  // A single grid governs both the option row and the label row beneath
  // it, so the min/max labels always line up with the first/last option
  // no matter how many options there are or how narrow the scale gets.
  return (
    <div className={`rating-scale rating-scale--${scaleType}`}>
      <div
        className={`rating-scale-grid${segmented ? ' rating-scale-grid--segmented' : ''}`}
        style={{ '--option-count': options.length }}
      >
        {options.map((option, index) => (
          <button
            key={option}
            type="button"
            className={`rating-scale-option${value === option ? ' selected' : ''}`}
            style={{ gridColumn: index + 1, gridRow: 1 }}
            aria-pressed={value === option}
            onClick={() => onChange(option)}
          >
            {option}
          </button>
        ))}
        {minLabel && (
          <span className="rating-scale-label" style={{ gridColumn: 1, gridRow: 2, justifySelf: 'start' }}>
            {minLabel}
          </span>
        )}
        {maxLabel && (
          <span className="rating-scale-label" style={{ gridColumn: options.length, gridRow: 2, justifySelf: 'end' }}>
            {maxLabel}
          </span>
        )}
      </div>
    </div>
  );
}

export default RatingScale;
